import { CalendarPage } from "@components/pages/CalendarPage"
import { SiteShell } from "@components/SiteShell"
import { getCalendarEvents } from "@data/eventsData"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/routeHead"
import { pageLabels } from "@utils/routeLabels"

export const Route = createFileRoute("/$locale/calendar")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: () => getCalendarEvents(),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "calendar", path: `/${locale}/calendar` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const events = Route.useLoaderData()
  const locale = routeLocale as "en" | "ja"
  const labels = pageLabels(locale, "calendar")
  return (
    <SiteShell
      locale={locale}
      page={labels.page}
    >
      <CalendarPage
        events={events}
        locale={locale}
      />
    </SiteShell>
  )
}
